import styled, { css } from 'styled-components';

import Input from '@polyai/ui/components/atoms/Input';
import {
  InputStyles,
  SharedInputStyles,
} from '@polyai/ui/components/atoms/Input/Input.styled';
import themeColors from '@polyai/ui/styles/config/colors';
import sizes from '@polyai/ui/styles/config/sizes';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

export const RichTextInputWrapper = styled.div`
  cursor: text;
  position: relative;
`;

export const Placeholder = styled.div.attrs({ contentEditable: false })`
  color: ${themeColors.textHelper};
`;

export const RichTextInput = styled.div<{
  $menuOpen?: boolean;
  $disabled?: boolean;
  $loading?: boolean;
}>`
  ${InputStyles}
  ${SharedInputStyles}
  display: inline-block;

  width: 100%;
  min-height: ${sizes.inputHeight};
  padding-right: ${themeSpacing.md1};

  font-weight: ${text.weight.regular};
  white-space: pre-wrap;

  &:focus {
    outline: none;
  }

  &:focus-within {
    border-color: ${themeColors.borderPrimary};
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      color: ${themeColors.textDisabled};
      background-color: ${themeColors.backgroundPage};
    `}

  ${({ $menuOpen }) =>
    $menuOpen &&
    css`
      border-color: ${themeColors.borderPrimary};
    `}

  ${({ $loading }) =>
    $loading &&
    css`
      visibility: hidden;
    `}
`;

export const AddActionTagButton = styled.div`
  position: absolute;
  right: ${themeSpacing.sm1};
  bottom: ${themeSpacing.sm1};
  transition: bottom 0.2s ease-in-out;
`;

export const ShortcutHint = styled.span`
  font-weight: ${text.weight.semibold};
  color: ${themeColors.textHelper};
`;

export const Hide = styled.span`
  display: inline-block;

  width: 0;
  height: 1rem;

  white-space: nowrap;

  opacity: 0;
`;

export const FakeCursor = styled.span`
  @keyframes blink {
    0%,
    100% {
      opacity: 1;
    }

    50% {
      opacity: 0;
    }
  }

  display: inline-block;

  width: 1px;
  height: 100%;
  margin-left: -0.5px;

  background-color: #000;

  animation: blink 1s infinite;
`;

export const SkeletonWrapper = styled.div`
  position: absolute;
  inset: 0;
`;

export const TextInput = styled(Input)`
  width: 100%;
  font-weight: ${text.weight.regular};
  background-color: ${themeColors.background};
`;
